import AspApi from "api/ApiConfig";

export const campaignListApi = async (brandId, query) => {
  let qpm = [];

  if (query?.page) qpm.push(`page=${query?.page}`);
  if (query?.limit) qpm.push(`limit=${query?.limit}`);
  if (query?.name) qpm.push(`name=${query?.name}`);
  if (query?.status) qpm.push(`status=${query?.status}`);

  let qpmString = "";
  if (qpm?.length > 0) qpmString = "" + qpm.join("&");

  const res = await AspApi.get(
    `/api/v1/campaigns?brand_id=${brandId}&${qpmString}`
  );
  return res;
};

export const campaignBroadcastListApi = async (brandId, query) => {
  let qpm = [];

  if (query?.page) qpm.push(`page=${query?.page}`);
  if (query?.limit) qpm.push(`limit=${query?.limit}`);
  if (query?.name) qpm.push(`name=${query?.name}`);
  if (query?.status) qpm.push(`status=${query?.status}`);

  let qpmString = "";
  if (qpm?.length > 0) qpmString = "" + qpm.join("&");

  const res = await AspApi.get(
    `/api/v1/campaigns/broadcast_campaigns?brand_id=${brandId}&${qpmString}`
  );
  return res;
};

export const createCampaignApi = async (payLoad) => {
  const res = await AspApi.post(`/api/v1/campaigns`, payLoad);
  return res;
};

export const updateCampaignApi = async (id, payLoad) => {
  const res = await AspApi.patch(`/api/v1/campaigns/${id}`, payLoad);
  return res;
};

export const checkCampaignExits = async (id, params) =>
  await AspApi.get(
    `/api/v1/campaigns/check_campaign_exists?brand_id=${id}&name=${params}`
  );

export const createSendApi = async (payLoad) => {
  const res = await AspApi.post(
    `api/v1/svc/whatsapp/conversations/send_template`,
    payLoad
  );
  return res;
};

// export const createSendApi = async (params) => {
//   // query params
//   // let qpm = [];
//   // if (params?.brandId) qpm.push(`brand_id=${params?.brandId}`);
//   // if (params?.metaTemplateId)
//   //   qpm.push(`meta_template_id=${params?.metaTemplateId}`);

//   // let qpmString = "";
//   // if (qpm?.length > 0) qpmString = "?" + qpm.join("&");

//   // body params
//   let bodyParams = {};
//   if (params?.sendFrom) bodyParams["from_number"] = params?.sendFrom;
//   if (params?.sendTo) bodyParams["to_number"] = params?.sendTo;
//   if (params?.brandId) bodyParams["brand_id"] = params?.brandId;
//   if (params?.metaTemplateId)
//     bodyParams["template_id"] = params?.metaTemplateId;
//   if (params?.subcategory_type)
//     bodyParams["subcategory_type"] = params?.subcategory_type;
//   if (params?.variables) bodyParams["variables"] = params?.variables;

//   const res = await AspApi.post(
//     `api/v1/svc/whatsapp/conversations/send_template`,
//     bodyParams
//   );
//   return res;
// };

export const campaignDelete = async (id, brandId) => {
  const res = await AspApi.delete(
    `/api/v1/campaigns/${id}?brand_id=${brandId}`
  );
  return res;
};

export const campaignDeleteBulk = async (payLoad) => {
  const res = await AspApi.delete(
    `/api/v1/campaigns/bulk_delete?brand_id=${payLoad?.brand_id}&bulk_delete=${payLoad?.bulk_delete}&except_campaign_ids=${payLoad?.except_campaign_ids}`
  );
  return res;
};

// CAMPAIGN/API - API

export const campaignAPI = async (brandId, query) => {
  let qpm = [];
  if (query?.page) qpm.push(`page=${query?.page}`);
  if (query?.limit) qpm.push(`limit=${query?.limit}`);
  if (query?.name) qpm.push(`name=${query?.name}`);
  if (query?.status) qpm.push(`status=${query?.status}`);

  let qpmString = "";
  if (qpm?.length > 0) qpmString = "" + qpm.join("&");
  const res = await AspApi.get(
    `/api/v1/campaigns/api_campaigns?brand_id=${brandId}&${qpmString}`
  );

  return res;
};

export const getApiCount = async (brandId, campaignId) => {
  const res = await AspApi.get(
    `/api/v1/svc/whatsapp/conversations/conversation_metrics_for_api_campaign?brand_id=${brandId}&campaign_id=${campaignId}`
  );
  return res;
};

export const ApiContactList = async (brandId, campaignId, query) => {
  let qpm = [];
  if (query?.page) qpm.push(`page=${query?.page}`);
  if (query?.limit) qpm.push(`limit=${query?.limit}`);
  if (query?.name) qpm.push(`name=${query?.name}`);
  if (query?.status) qpm.push(`status=${query?.status}`);

  let qpmString = "";
  if (qpm?.length > 0) qpmString = "" + qpm.join("&");

  const res = await AspApi.get(
    // `api/v1/conversations/contacts?brand_id=${brandId}&campaign_id=${campaignId}&${qpmString}`
    `api/v1/svc/whatsapp/conversations/conversation_list_for_api_campaign?brand_id=${brandId}&campaign_id=${campaignId}&${qpmString}`
  );
  return res;
};

// BROADCAST - API ----------------------------------------

export const broadCastCreateApi = async (brandId, id, payLoad) => {
  const res = await AspApi.post(
    `/api/v1/svc/campaign_broadcast/broadcasts?brand_id=${brandId}&campaign_id=${id}`,
    payLoad
  );
  return res;
};

export const broadCastListApi = async (brandId, campaignId, query) => {
  let qpm = [];
  if (query?.page) qpm.push(`page=${query?.page}`);
  if (query?.limit) qpm.push(`limit=${query?.limit}`);
  if (query?.name) qpm.push(`name=${query?.name}`);
  if (query?.status) qpm.push(`status=${query?.status}`);

  let qpmString = "";
  if (qpm?.length > 0) qpmString = "" + qpm.join("&");

  const res = await AspApi.get(
    `/api/v1/svc/campaign_broadcast/broadcasts?brand_id=${brandId}&campaign_id=${campaignId}&${qpmString}`
  );
  return res;
};

export const broadcastSingleApi = async (brandId, campaignId, broadcastId) => {
  const res = await AspApi.get(
    `/api/v1/svc/campaign_broadcast/broadcasts/${broadcastId}?brand_id=${brandId}&campaign_id=${campaignId}`
  );
  return res;
};

export const broadcastTryAgain = async (brandId, broadcastId) => {
  const res = await AspApi.put(
    `/api/v1/svc/campaign_broadcast/broadcasts/${broadcastId}/reactivate?brand_id=${brandId}`
  );
  return res;
};

export const broadcastDeleteApi = async (brandId, campaignId, id) => {
  const res = await AspApi.delete(
    `/api/v1/svc/campaign_broadcast/broadcasts/${id}?brand_id=${brandId}&campaign_id=${campaignId}`
  );

  return res;
};
export const broadcastSegmentApi = async (id, brandId, campaignId) => {
  const res = await AspApi.get(
    `/api/v1/svc/campaign_broadcast/broadcasts/${id}?brand_id=${brandId}&campaign_id=${campaignId}`
  );
  return res;
};

export const getBroadcastCountApi = async (brandId, campaignId) => {
  const res = await AspApi.get(
    `/api/v1/campaigns/${campaignId}/metric?brand_id=${brandId}`
  );
  return res;
};

export const broadCastContactListApi = async (
  brandId,
  broadcastId,
  broadcastPartId,
  query
) => {
  let qpm = [];
  if (query?.page) qpm.push(`page=${query?.page}`);
  if (query?.limit) qpm.push(`limit=${query?.limit}`);
  if (query?.name) qpm.push(`name=${query?.name}`);
  if (query?.status) qpm.push(`status=${query?.status}`);
  if (query?.download_all) qpm.push(`download_all=${query?.download_all}`);

  let qpmString = "";
  if (qpm?.length > 0) qpmString = "" + qpm.join("&");

  const res = await AspApi.get(
    `api/v1/svc/whatsapp/conversations/broadcast_conversation_list?brand_id=${brandId}&broadcast_id=${broadcastId}&broadcast_part_id=${broadcastPartId}&${qpmString}`
  );
  return res;
};

// BROADCAST PART - API ----------------------------------------

export const broadcastPartApi = async (id, payLoad) => {
  const res = await AspApi.post(
    `/api/v1/svc/campaign_broadcast/broadcasts/${id}/broadcast_parts`,
    payLoad
  );
  return res;
};

export const broadcastPartFileData = async (id, broadcastPartId, payLoad) => {
  const res = await AspApi.post(
    `/api/v1/svc/campaign_broadcast/broadcasts/${id}/broadcast_parts/${broadcastPartId}/file_data`,
    payLoad
  );
  return res;
};

export const getBroadcastPartApi = async (id, brandId) => {
  const res = await AspApi.get(
    `/api/v1/svc/campaign_broadcast/broadcasts/${id}/broadcast_parts?brand_id=${brandId}`
  );
  return res;
};

export const broadcastPartDeleteApi = async (
  responseId,
  responseFromApi,
  brandId
) => {
  const res = await AspApi.delete(
    `/api/v1/svc/campaign_broadcast/broadcasts/${responseId}/broadcast_parts/${responseFromApi}?brand_id=${brandId}`
  );
  return res;
};
export const broadcastTemplateListApi = async (brandId, status, query) => {
  let qpm = [];

  if (query?.page) qpm.push(`page=${query?.page}`);
  if (query?.limit) qpm.push(`limit=${query?.limit}`);
  if (query?.name) qpm.push(`name=${query?.name}`);
  if (query?.status) qpm.push(`status=${query?.status}`);

  let qpmString = "";
  if (qpm?.length > 0) qpmString = "" + qpm.join("&");

  const res = await AspApi.get(
    `/api/v1/svc/whatsapp/template_utils/whatsapp_template_list?brand_id=${brandId}&status=${status}&${qpmString}`
  );
  return res;
};
export const createActivateApi = async (id, payLoad) => {
  const res = await AspApi.post(
    `/api/v1/svc/campaign_broadcast/broadcasts/${id}/activate`,
    payLoad
  );
  return res;
};

export const templateList = async (brandId, templateId) => {
  const res = await AspApi.get(
    `api/v1/svc/whatsapp/template_utils/${templateId}?brand_id=${brandId}`
  );
  return res;
};

export const draftApi = async (payLoad) => {
  const { broadcast_id, ...payLoadData } = payLoad;
  const res = await AspApi.put(
    `/api/v1/svc/campaign_broadcast/broadcasts/${broadcast_id}/draft`,
    payLoadData
  );
  return res;
};
// plan api

export const downgradeApi = async (payLoad) => {
  const res = await AspApi.post(`/api/v1/transactions/downgrade_plan`, payLoad);
  return res;
};
